import IconButton from '@material-ui/core/IconButton'
import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import PencilIcon from '@material-ui/icons/Edit'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import Icon from '@mdi/react'
import { mdiNoteEditOutline } from '@mdi/js'

import consts from '../../../util/consts'
import Paginate from '../../components/Pagination'
import { fetchClientPlan } from '../ClientPlanActions'
import { exportFormatedMoney } from '../../../util/utils'
import {
  StyledTableCellBody,
  StyledTableCellHeader,
} from '../../../components/hooks/BaseTableComponents'

function List(props) {
  const dispatch = useDispatch()

  const items = useSelector(state => state.clientPlan.items)
  const filters = useSelector(state => state.clientPlan.filters)
  const totalSize = useSelector(state => state.clientPlan.totalSize)
  const page = useSelector(state => state.clientPlan.page)

  const [rowsPerPage, setRowsPerPage] = useState(consts.DEFAULT_PAGINATION)
  const { classes } = props

  const onMovePage = (event, newPage) => {
    dispatch(fetchClientPlan(newPage + 1, filters, rowsPerPage))
  }

  useEffect(() => {
    onMovePage()
  }, [rowsPerPage])

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(event.target.value)
  }

  return (
    <TableContainer className={classes.tableContainer}>
      <Table size="small" className={classes.tableStyle}>
        <TableHead>
          <TableRow>
            <StyledTableCellHeader>ID</StyledTableCellHeader>
            <StyledTableCellHeader>Nome</StyledTableCellHeader>
            <StyledTableCellHeader>Descrição</StyledTableCellHeader>
            <StyledTableCellHeader>Mãximo de Usuários</StyledTableCellHeader>
            <StyledTableCellHeader>Valor</StyledTableCellHeader>
            <StyledTableCellHeader>Ativo</StyledTableCellHeader>
            <StyledTableCellHeader>Ações</StyledTableCellHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {items?.map(item => (
            <TableRow key={item.id}>
              <StyledTableCellBody>{item.id}</StyledTableCellBody>
              <StyledTableCellBody>{item.name}</StyledTableCellBody>
              <StyledTableCellBody>{item.description}</StyledTableCellBody>
              <StyledTableCellBody>{item.max_users}</StyledTableCellBody>
              <StyledTableCellBody>
                {exportFormatedMoney(item.price)}
              </StyledTableCellBody>
              <StyledTableCellBody>
                {item.is_active == 1 ? 'Sim' : 'Não'}
              </StyledTableCellBody>
              <StyledTableCellBody>
                <IconButton
                  component={Link}
                  to={`/client-plan/${item.id}/edit`}
                >
                  <Icon path={mdiNoteEditOutline} size={1} />
                </IconButton>
              </StyledTableCellBody>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Paginate
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        rowsPerPage={rowsPerPage}
        rows={totalSize}
        page={page - 1}
        handleChangePage={onMovePage}
      />
    </TableContainer>
  )
}

export default List
